import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Header } from './components/Header'
import { Hero } from './components/Hero'
import { ScamExplained } from './components/ScamExplained'
import { OurSolution } from './components/OurSolution'
import { Authority } from './components/Authority'
import { Testimonials } from './components/Testimonials'
import { Product } from './components/Product'
import { Sources } from './components/Sources'
import { Legal } from './components/Legal'
import { Footer } from './components/Footer'
import { SavingsCalculator } from './components/Calculator/SavingsCalculator'
import { Register } from './components/Auth/Register'
import { ThankYou } from './components/ThankYou'
import { Checkout } from './components/Checkout/Checkout'
import { ExitClub } from './components/ExitClub'
import { PaymentSuccess } from './components/Checkout/PaymentSuccess'
import { AIChatbot } from './components/Chatbot/AIChatbot'

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white">
        {/* Header - now shows consistent navigation without auth state */}
        <Header />
        
        <Routes>
          {/* Main landing page */}
          <Route path="/" element={
            <>
              <Hero />
              <ScamExplained />
              <OurSolution />
              <SavingsCalculator />
              <Authority />
              <ExitClub />
              <Testimonials />
              <Product />
              <Sources />
              <Legal />
            </>
          } />
          
          {/* Calculator page */}
          <Route path="/calculator" element={
            <>
              <div className="pt-20">
                <SavingsCalculator />
              </div>
            </>
          } />
          
          {/* Registration flow - now leads to thank you */}
          <Route path="/register" element={<Register />} />
          <Route path="/thank-you" element={<ThankYou />} />
          
          {/* Checkout flow (for future payment integration) */}
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/checkout/success" element={<PaymentSuccess />} />
        </Routes>
        
        {/* Global components */}
        <AIChatbot />
        
        {/* Footer on main pages, not on auth/checkout pages */}
        <Routes>
          <Route path="/register" element={null} />
          <Route path="/thank-you" element={null} />
          <Route path="/checkout" element={null} />
          <Route path="/checkout/success" element={null} />
          <Route path="*" element={<Footer />} />
        </Routes>
      </div>
    </Router>
  )
}

export default App
